import {ShapeCommand} from '../commands.template';

export class TextChangeStyleCommand extends ShapeCommand {
  services: any;
  firstAction;
  boolean;
  reverseStyleChange: any;
  constructor(data) {
    super(data);
    this.firstAction = true;
  }

  prepareData() {
    const textJson = this.services.jsonHandlerSvc.get().texts.find(t => {
      return Number(t.mxKey) === Number(this.object.mxKey);
    });

    this.reverseStyleChange = {
      mxKey: textJson.mxKey,
      style: textJson.style,
      customStyle: textJson.customStyle
    };

    return this;
  }

  public execute() {
    super.execute();

    return this.sendChanges(this.object);
  }

  public reverse() {
    super.reverse();

    return this.sendChanges(this.reverseStyleChange);
  }

  private sendChanges(styleChange) {
    const mxStyles = [
      'strokeColor',
      'fillColor',
      'strokeWidth',
      'fontColor',
      'shadow',
      'fontFamily',
      'align',
      'verticalAlign'
    ];
    const ourStyles = [
      'borderColor',
      'backgroundColor',
      'borderWidth',
      'fontColor',
      'shadow',
      'font',
      'textAlign',
      'verticalAlign'
    ];

    this.services.graphHelperSvc.mxStyleApply(
      mxStyles,
      ourStyles,
      styleChange.mxKey,
      styleChange.customStyle,
      styleChange.style,
      'text'
    );

    const action: any = {
      changeText: {
        mxKey: styleChange.mxKey,
        customStyle: styleChange.customStyle
      }
    };

    if (styleChange.customStyle) {
      action.changeText.style = styleChange.style;
    }

    this.services.diagramUpdateSvc.update(action);
  }
}
